module.exports = __webpack_public_path__ + "static/media/Nota Mermeladas.f6c2e6dd.webp";